import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { YoutubeStatsContainerV1 } from './v1/YoutubeStatsContainerV1';
import { YoutubeStatsContainerV2 } from './v2/YoutubeStatsContainerV2';

/**
 * Picks logger (v1) vs BFF (v2) from GrowthBook; each branch owns its own data hooks.
 */
export default function YoutubeStatsContainer() {
  const useYoutubeStatsV2 = useFeatureIsOn('app__youtube_stats_use_v2_api');
  return useYoutubeStatsV2 ? <YoutubeStatsContainerV2 /> : <YoutubeStatsContainerV1 />;
}
